// utilities.js
export function animateCount(initialValue, targetValue, setFunction, onComplete) {
    if (initialValue === targetValue) {
        setFunction(targetValue);
        if (onComplete) onComplete();
        return;
    }

    const duration = 400;
    const step = initialValue < targetValue ? 1 : -1;
    const steps = Math.abs(targetValue - initialValue);
    const interval = Math.floor(duration / steps);

    const counter = setInterval(() => {
        initialValue += step;
        setFunction(initialValue);

        if ((step > 0 && initialValue >= targetValue) || (step < 0 && initialValue <= targetValue)) {
            clearInterval(counter);
            if (onComplete) onComplete();
        }
    }, interval);

    // Return cleanup function
    return () => clearInterval(counter);
}
